// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.popShow {\n  padding: 10px;\n  font-size: 12px;\n  border: 1px solid #ddd;\n}\n", ""]);
// Exports
module.exports = exports;
